import { credentials } from './credentials';

export const localStorage = { credentials };
